export const edgeJob = {
    "STANDARD": "Стандарт",
    "HANDMADE": "Ручная",
}